import { useVisitorData } from '@fingerprint/vue'

type FingerprintCheckoutEventPayload = {
    eventId: string
    sealedResult: string | null
}

export function useFingerprintCheckoutEventPayload() {
    if (process.server) {
        async function getFingerprintCheckoutEventPayload() {
            return null
        }

        return { getFingerprintCheckoutEventPayload }
    }

    try {
        const { data, getData } = useVisitorData({
            immediate: false
        })

        async function getFingerprintCheckoutEventPayload() {
            return await getData()
                .then(result => {
                    // Checkout fraud review needs a fresh Fingerprint event
                    // for each submit attempt. The sealed result is optional
                    // because Fingerprint omits it unless Sealed Results are
                    // enabled for the account.
                    return {
                        eventId: result.event_id,
                        sealedResult: result.sealed_result?.base64() ?? null
                    }
                })
                .catch(() => {
                    if (data.value?.event_id === undefined) {
                        // Browser extensions, local config, or network errors
                        // should not block checkout itself.
                        return null
                    }

                    // If the composable already has a successful event, use it
                    // even when this specific call failed.
                    return {
                        eventId: data.value.event_id,
                        sealedResult: data.value.sealed_result?.base64() ?? null
                    }
                })
        }

        return { getFingerprintCheckoutEventPayload }
    } catch {
        async function getFingerprintCheckoutEventPayload() {
            // If the Vue plugin is unavailable for any unexpected reason,
            // continue without checkout fraud context rather than blocking.
            return null
        }

        return { getFingerprintCheckoutEventPayload }
    }
}
